import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface EmptyCheckBadgeProps {
  className?: string;
}

/**
 * Empty circle in the corner of an unselected option, sitting where the
 * checkmark badge of a selected option sits, so the tiles read as a choice.
 * Decorative like the badge, and its parent needs a `relative` position too,
 * unless the caller places it in the flow with `className`.
 */
export function EmptyCheckBadge({ className }: Readonly<EmptyCheckBadgeProps>) {
  return (
    <span
      aria-hidden="true"
      data-testid="empty-check-badge"
      className={twMerge(
        'absolute left-2 top-2 h-5 w-5 rounded-full border border-neutral-50 bg-white',
        className,
      )}
    />
  );
}
